<template>
  <div class="zj-startup">
    <div class="zj-startup-box">
      <el-progress :percentage="percent" :show-text="false"></el-progress>
      <p>{{msg}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZjStartup',
  props: {
    percent: {
      type: Number,
      default: 0
    },
    msg: String
  }
}
</script>
